import Checkbox from '@ubnt/ui-components/Checkbox/Checkbox';
import { memo } from 'react';

import SettingsTile from './SettingsTile';

interface DisplayOptionsTileProps {
  onShowAnimationChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onShowDeviceNameChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  showAnimation: boolean;
  showDeviceName: boolean;
}

const DisplayOptionsTileImpl = (props: DisplayOptionsTileProps) => {
  const { onShowAnimationChange, onShowDeviceNameChange, showAnimation, showDeviceName } = props;

  return (
    <SettingsTile>
      <Checkbox checked={showDeviceName} id="showDeviceNames" onChange={onShowDeviceNameChange}>
        Show Device Names
      </Checkbox>
      <Checkbox checked={showAnimation} id="showAnimation" onChange={onShowAnimationChange}>
        Show Animation
      </Checkbox>
    </SettingsTile>
  );
};

const DisplayOptionsTile = memo(DisplayOptionsTileImpl);

export default DisplayOptionsTile;
